import { Link } from "react-router-dom";
import BaseCom from "../../../../components/BaseCom";
import Icon from "../../../../components/Icon";
import L from "../../../../components/Lang";
import AppActions from "../../../../components/Solusek/AppActions";
import DataView from "../../../../components/Solusek/DataView";
import { withParamsAndNavigate } from "../../../../components/WithParamsAndNavigate";
import { Pop } from "../../../../components/PopModal";

class HealthCheckManager extends BaseCom {

    remove = (item) => {
        Pop.showConfirm(<L>Delete Health Check</L>, <><L>Are you sure you want to delete</L> <strong>{item.name}</strong>?</>, async () => {
            await this.postOrAlert('/api/admin/healthcheck/delete', item);
            this.success('Deleted.');
            this.rehash();
        });
    }

    edit = (item) => {
        this.props.navigate(String(item.id));
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Health Check</L></h1>
                <DataView api={'/api/admin/healthcheck/list'} hash={this.state.hash}
                    addons={[{
                        contentFunc: row => <div>
                            {row.isActive ? <span className="text-success"><Icon icon="faCircle" /></span>
                                : <span className="text-muted"><Icon icon="faCircle" /></span>}
                        </div>
                    }]}

                    actions={[
                        {
                        label: <Icon icon="faPencil" />,
                        onClick: this.edit
                    },
                    {
                        label: <Icon icon="faTrash" />,
                        danger: true,
                        onClick: this.remove
                    }
                    ]}

                />
                <AppActions>
                    <Link to="new" className="btn btn-lg btn-primary">
                        <Icon icon="faPlus" /> <L>New Health Check</L>
                    </Link>
                </AppActions>
            </div>
        );
    }
}

export default withParamsAndNavigate(HealthCheckManager);